export const menuGroups = [
    {
        title: 'Community',
        items: {
            'Discord': 'https://discord.gg/xs8VESN4yz',
            'Twitter': 'https://twitter.com/tetu_io',
            'Medium': 'https://medium.com/@tetu.finance',
            'Artworks': 'https://drive.google.com/drive/folders/1sKDLb3SXH-86oq1cduvPhLJYppdCzJIm',
        }
    },
    {
        title: 'Resources',
        items: {
            'GitHub': 'https://github.com/tetu-io',
            'Documentations': 'https://docs.tetu.io/tetu-io/',
            'Brand kit': 'https://github.com/tetu-io/tetu-brand-assets',
            'Audit reports': 'https://docs.tetu.io/tetu-io/security/audits',
            'DeFiSafety review': 'https://docs.defisafety.com/master/tetu-finance-process-quality-review',
        }
    },
    {
        title: 'Product',
        items: {
            'Invest/ Vaults': 'https://app.tetu.io/',
            'TETU-swap': 'https://swap.tetu.io/#/swap',
        }
    },
];
